import { render, staticRenderFns } from "./red_talent6.vue?vue&type=template&id=03ece0b8&scoped=true"
import script from "./red_talent6.vue?vue&type=script&lang=js"
export * from "./red_talent6.vue?vue&type=script&lang=js"
import style0 from "./red_talent6.vue?vue&type=style&index=0&id=03ece0b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ece0b8",
  null
  
)

export default component.exports